import { render, staticRenderFns } from "./AddtrainerDashboard.vue?vue&type=template&id=30fbdde5"
import script from "./AddtrainerDashboard.vue?vue&type=script&lang=js"
export * from "./AddtrainerDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports